function getScaledImage(originalWidth, originalHeight) {
  let maxDimension = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 144;
  let minBaseDimension = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 72;
  let scaledWidth = originalWidth;
  let scaledHeight = originalHeight;
  const aspectRatio = originalWidth / originalHeight;
  if (originalWidth > maxDimension || originalHeight > maxDimension) {
    if (originalWidth > originalHeight) {
      // Scale width to maxDimension
      scaledWidth = maxDimension;
      scaledHeight = Math.round(maxDimension / aspectRatio);
    } else {
      // Scale height to maxDimension
      scaledHeight = maxDimension;
      scaledWidth = Math.round(maxDimension * aspectRatio);
    }
  }
  if (scaledWidth < maxDimension && scaledHeight < maxDimension) {
    if (scaledWidth > scaledHeight) {
      // Scale width to minBaseDimension
      scaledWidth = minBaseDimension;
      scaledHeight = Math.round(minBaseDimension / aspectRatio);
    } else {
      // Scale height to minBaseDimension
      scaledHeight = minBaseDimension;
      scaledWidth = Math.round(minBaseDimension * aspectRatio);
    }
  }
  return {
    width: scaledWidth,
    height: scaledHeight
  };
}
export { getScaledImage };